import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	expenseHistory: null,
	total: 0,
	expense: null,
	error: "",
	loading: false,
};

// ADD_Expense
export const addExpenseForm = createAsyncThunk(
	"expense/addExpenseForm",
	async (values) => {
		try {
			console.log("slice values", values)
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					// "Content-Type": "application/json;charset=UTF-8",
					"Content-Type": "multipart/form-data",
				},
				url: `expense-form/`,
				data: {
					...values,
				},
			},
			);
			console.log("data", data)
			toast.success("Expense Created");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in creating expense, try again!");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// Approve_Expense
export const reviewExpenseForm = createAsyncThunk(
	"expense/reviewExpenseForm",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `expense-form/${id}`,
				data: {
					...values,
				},
			});

			toast.success(" Expense Approved");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in approving try again");
			console.log(error.message);
		}
	}
);

// Expense_DETAILS
export const loadSingleExpenseForm = createAsyncThunk(
	"expense/loadSingleExpenseForm",
	async (id) => {
		try {
			const data = await axios.get(`expense-form/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// get expense by status and pagination
export const loadExpenseFormByStatus = createAsyncThunk(
	"expense/loadExpenseFormByStatus",
	async ({  page, limit, approvalStatus }) => {
		console.log("approvalStatus", approvalStatus);
		
		try {
			const { data } = await axios.get(
				`expense-form?page=${page}&count=${limit}&approvalStatus=${approvalStatus}`
			);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// Expenses
export const loadAllExpenseForm = createAsyncThunk(
	"expense/loadAllExpenseForm",
	async () => {
		try {
			const { data } = await axios.get(`expense-form?query=all`);

			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// count expense forms
export const countExpenseForm = createAsyncThunk(
	"expense/countExpenseForm",
	async () => {
		try {
			const { data } = await axios.get(`expense-form`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// get Single Expense history
export const loadSingleExpenseHistory = createAsyncThunk(
	"expense/loadSingleExpenseHistory",
	async (id) => {
		// console.log("gettinIDfromComponent", id);
		try {
			const { data } = await axios.get(`expense-form/expense-history/${id}/`);
			// console.log("dataFromAPI: ", data);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateExpenseForm = createAsyncThunk(
	"expense/updateExpenseForm",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `expense-form/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Expense Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Expense try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const ExpenseFormSlice = createSlice({
	name: "expenseForm",
	initialState,
	reducers: {
		clearExpenseForm: (state) => {
			state.expense = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllExpenseForm ======

		builder.addCase(loadAllExpenseForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllExpenseForm.fulfilled, (state, action) => {
			state.loading = false;

			state.list = action.payload;
		});

		builder.addCase(loadAllExpenseForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		builder.addCase(addExpenseForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addExpenseForm.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addExpenseForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for loadSingleExpenseForm ======

		builder.addCase(loadSingleExpenseForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleExpenseForm.fulfilled, (state, action) => {
			state.loading = false;
			state.expense = action.payload.data;
		});

		builder.addCase(loadSingleExpenseForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadExpenseFormByStatus ======

		builder.addCase(loadExpenseFormByStatus.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadExpenseFormByStatus.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadExpenseFormByStatus.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for updateExpenseForm ======

		builder.addCase(updateExpenseForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateExpenseForm.fulfilled, (state, action) => {
			state.loading = false;
			const list = [...state.list];
			const index = list.findIndex(
				(expense) => expense.id === parseInt(action.payload.data.id)
			);
			list[index] = action.payload.data;
			state.list = list;
		});

		builder.addCase(updateExpenseForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for reviewExpenseForm ======

		builder.addCase(reviewExpenseForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(reviewExpenseForm.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(reviewExpenseForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 5) ====== builders for countExpenseForm ======

		builder.addCase(countExpenseForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(countExpenseForm.fulfilled, (state, action) => {
			state.loading = false;
			const length = action.payload.length;
			state.total = length;
		});

		builder.addCase(countExpenseForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 6) ====== builders for loadSingleExpenseHistory ======

		builder.addCase(loadSingleExpenseHistory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleExpenseHistory.fulfilled, (state, action) => {
			console.log(action.payload);
			state.loading = false;
			state.expenseHistory = action.payload;
		});

		builder.addCase(loadSingleExpenseHistory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default ExpenseFormSlice.reducer;
export const { clearExpenseForm } = ExpenseFormSlice.actions;
